/* tslint:disable */

declare var Object: any;
export interface StockLocationInterface {
  "id"?: number;
  "name": string;
  "complete_name"?: string;
  "lot_location_ids"?: number;
}

export class StockLocation implements StockLocationInterface {
  "id": number;
  "name": string;
  "complete_name": string;
  "lot_location_ids": number;
  constructor(data?: StockLocationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StockLocation`.
   */
  public static getModelName() {
    return "StockLocation";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StockLocation for dynamic purposes.
  **/
  public static factory(data: StockLocationInterface): StockLocation{
    return new StockLocation(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StockLocation',
      plural: 'StockLocations',
      path: 'StockLocations',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "complete_name": {
          name: 'complete_name',
          type: 'string'
        },
        "lot_location_ids": {
          name: 'lot_location_ids',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/StockLocation.ts